import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncEditFormContainer({ ...rest }) {
  const AsyncLoad = loadable(() => import("../EditFormContainer"));
  console.log("Loading", AsyncEditFormContainer.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncEditFormContainer;
